import React, { useEffect, useState } from "react";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";
import { exchangeObj, exchangeType, parseDate } from "../../constant/enum";
import GridTable from "../../constant/GridTable";
import moment from "moment";
import {
  useDeleteUserExchangeApiMutation,
  useGetUserAccountQuery,
  useGetUserExchnageApiQuery,
  useSetUserExchnageApiMutation,
} from "../../../redux/userExchangeApi";
import { toast } from "react-toastify";
import copy from "copy-to-clipboard";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

function ExchnageApi() {
  const [setUserExchnageApi] = useSetUserExchnageApiMutation();
  const [deleteUserExchangeApi] = useDeleteUserExchangeApiMutation();
  const { data: userAccount } = useGetUserAccountQuery({});
  const { data: userApi } = useGetUserExchnageApiQuery({});
  const [exchange, setExchange] = useState("");
  const [exchangeErr, setExchangeErr] = useState("");
  const [apikey, setApikey] = useState("");
  const [apikeyErr, setApikeyErr] = useState("");
  const [secretkey, setSecretkey] = useState("");
  const [secretkeyErr, setSecretkeyErr] = useState("");
  const [disable, setDisable] = useState(false);
  const [manageLength, setManageLength] = useState(0);
  const [back, setBack] = useState(false)
  const [id, setId] = useState("")

  function validateKey(value) {
    return /^[a-zA-Z0-9](?:[a-zA-Z0-9_-]*[a-zA-Z0-9])?$/.test(value);
  }

  useEffect(() => {
    if (userApi) {
      setManageLength(userApi.length);
    }
  }, [userApi]);

  const handleCopy = (text, type) => {
    copy(text);
    toast.dismiss();
    toast.success(`${type} copied successfully.`);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "exchange") {
      setExchange(value);
      if (value === "") {
        setExchangeErr("This field is required.");
      } else {
        setExchangeErr("");
      }
    }
    if (name === "apikey") {
      if (value.length <= 150) {
        setApikey(value);
        if (value === "") {
          setApikeyErr("This field is required.");
          return;
        }
        if (!validateKey(value)) {
          setApikeyErr(
            "Api key should not accept start and end special character."
          );
        } else {
          setApikeyErr("");
        }
      }
    }
    if (name === "secretkey") {
      if (value.length <= 150) {
        setSecretkey(value);
        if (value === "") {
          setSecretkeyErr("This field is required.");
          return;
        }
        if (!validateKey(value)) {
          setSecretkeyErr(
            "Secret key should not accept start and end special character."
          );
        } else {
          setSecretkeyErr("");
        }
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (exchange === "") {
      setExchangeErr("This field is required.");
      return;
    }
    if (apikey === "") {
      setApikeyErr("This field is required.");
      return;
    }
    if (!validateKey(apikey)) {
      setApikeyErr(
        "Api key should not accept start and end special character."
      );
      return;
    }
    if (secretkey === "") {
      setSecretkeyErr("This field is required.");
      return;
    }
    if (!validateKey(secretkey)) {
      setSecretkeyErr(
        "Secret key should not accept start and end special character."
      );
      return;
    }
    const sendData = {
      exchange_type: exchange,
      apikey: apikey,
      secretkey: secretkey,
      id:id
    };
    setDisable(true);
    setUserExchnageApi(sendData).then((result) => {
      if (result.error) {
        setDisable(false);
        toast.dismiss();
        toast.error(result.error.data.message);
        return;
      }
      if (result.data.status) {
        toast.dismiss();
        toast.success(result.data.message);
        setDisable(false);
        setApikey("");
        setSecretkey("");
        setExchange("");
      } else {
        toast.dismiss();
        toast.error(result.data.message);
        setDisable(false);
      }
    });
  };

  const [colDefs] = useState([
    {
      headerName: "Sr.No.",
      field: "id",
      valueGetter: "node.rowIndex + 1",
      sortable: true,
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Exchange",
      field: "exchange_type",
      sortable: true,
      cellRenderer: (params) => {
        return (
          <>
            {
              exchangeType.filter(
                (list) => list.value == params.data.exchange_type
              )[0]?.key
            }
          </>
        );
      },
      filter: "agTextColumnFilter",
    },

    {
      headerName: "Asstes",
      field: "assets",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Balance",
      field: "balance",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Available Balance",
      field: "available_balance",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Date",
      field: "createdAt",
      cellRenderer: (params) => {
        return <>{moment(params.value).format("lll")}</>;
      },
      sortable: true,
      filter: "agDateColumnFilter",
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          const cellDate = parseDate(cellValue);
          if (!cellDate) {
            return -1;
          }
          if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
            return 0;
          }
          return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
      },
    },
  ]);

  const deleteAlert = (id) => {
    confirmAlert({
      title: "Confirm Delete",
      message: "Do you want to delete this apikey?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteFun(id),
        },
        {
          label: "No",
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  };

  const deleteFun = (id) => {
    const sendData = { id };
    setDisable(true);
    deleteUserExchangeApi(sendData).then((res) => {
      if (res.data.status) {
        setDisable(false);
        toast.dismiss();
        toast.success(res.data.message);
      } else {
        setDisable(false);
        toast.dismiss();
        toast.error(res.data.message);
      }
    });
  };

  const handleEdit=(value)=>{
    setManageLength(manageLength-1)
    setExchange(value.exchange_type)
    setApikey(atob(value?.apikey))
    setSecretkey(atob(value?.secretkey))
    setId(value?.id)
    setBack(true)
  }

  const handleBack=()=>{
    setManageLength(manageLength+1)
    setExchange("")
    setApikey("")
    setSecretkey("")
    setBack(false)
    setId("")
  }

  return (
    <>
      <Header />
      <div className="in_page ">
        <div className="container">
          <div className="mt-2">
            <div className="row">
              <div className="col-md-4">
                <h2 className="mb-3 ">Exchnage Api</h2>
                {manageLength !== 2 && (
                  <div className="api-field">
                    <h5>Api Bind</h5>
                    <form onSubmit={handleSubmit}>
                      <div className="mb-2">
                        <label className="form-label">Exchange</label>
                        <select
                          className="form-control"
                          value={exchange}
                          onChange={handleChange}
                          name="exchange"
                        >
                          <option value="">Select</option>
                          {exchangeType?.map((list) => {
                            return (
                              <option value={list.value} key={list.key}>
                                {list.key}
                              </option>
                            );
                          })}
                        </select>
                        <span className="text-danger">{exchangeErr}</span>
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Apikey*</label>
                        <input
                          className="form-control "
                          placeholder="Enter Apikey"
                          value={apikey}
                          onChange={handleChange}
                          name="apikey"
                          maxLength={150}
                          onInput={(event) => {
                            const value = event.target.value;
                            const filteredValue = value.replace(
                              /[^0-9a-zA-Z._-]/g,
                              ""
                            );
                            if (value !== filteredValue) {
                              event.target.value = filteredValue;
                            }
                          }}
                        />
                        <span className="text-danger">{apikeyErr}</span>
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Secretkey*</label>
                        <input
                          className="form-control"
                          placeholder="Enter Secretkey"
                          value={secretkey}
                          onChange={handleChange}
                          name="secretkey"
                          maxLength={150}
                          onInput={(event) => {
                            const value = event.target.value;
                            const filteredValue = value.replace(
                              /[^0-9a-zA-Z._-]/g,
                              ""
                            );
                            if (value !== filteredValue) {
                              event.target.value = filteredValue;
                            }
                          }}
                        />
                        <span className="text-danger">{secretkeyErr}</span>
                      </div>

                      <div className="mb-2 pt-2">
                        <button
                          className="btn btn2 w100"
                          type="submit"
                          disabled={disable}
                        >
                          {disable ? "Loading..." : "Submit"}
                        </button>
                        {back && 
                        <button
                        className="btn btn2 w100 mt-2"
                        type="button"
                        onClick={()=>{handleBack()}}
                      >
                        Reject
                      </button>
                        }
                      </div>
                    </form>
                  </div>
                )}
                {userApi && userApi.length > 0 && (
                  <div>
                    {userApi.map((list) => {
                      return (
                        <div className="ex-api mb-2">
                          <div className="ex-api-inner-action">
                            <p >
                              <b>Exchange : </b> 
                              {exchangeObj[list.exchange_type]}
                            </p>
                            <p className="action-btn ">
                              <button
                                onClick={() => deleteAlert(list.id)}
                                className="del-span"
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                              <button
                                onClick={() => handleEdit(list)}
                                className="ed-span ms-3"
                              >
                                <i className="bi bi-pencil"></i>
                              </button>
                            </p>
                          </div>
                          <p className="mb-2">
                            <b>Api key : </b>
                          </p>
                          <p title={atob(list.apikey)}>
                            {atob(list.apikey).slice(0, 30) + "..."}{" "}
                            <span
                              className="ms-3"
                              onClick={() => {
                                handleCopy(atob(list.apikey), "Apikey");
                              }}
                            >
                              <i className="bi bi-copy"></i>
                            </span>
                          </p>
                          <p className="mb-2">
                            <b>Private key : </b>
                          </p>
                          <p title={atob(list.secretkey)}>
                            {atob(list.secretkey).slice(0, 28) + "..."}{" "}
                            <span
                              className="ms-3"
                              onClick={() => {
                                handleCopy(atob(list.secretkey), "Secretkey");
                              }}
                            >
                              <i className="bi bi-copy"></i>
                            </span>
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="col-md-8">
                <div>
                  <div>
                    <GridTable data={userAccount} colDefs={colDefs} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ExchnageApi;
